import React, { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { AnimatedContainer, ButtonLoadingForm, FormContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import {
  ChangeMethodContainer,
  ContainerForm,
  InstructionsContainer,
  PaymentMethodContainer,
  PlanInfoContainer,
  PlanPriceContainer,
  PriceContainer,
  SelectedPaymentMethod,
  SelectedPlanContainer,
} from './styles';
import { PaymentMethodEnum } from '../../../enums/PaymentMethodEnum';

import PixIcon from '../../../assets/pix-icon.svg';
import InputMask from '../../../components/InputMask';
import getValidationCPF from '../../../utils/getValidationCPF';
import getValidationErrors from '../../../utils/getValidationErrors';

interface formProps {
  cpf: string;
}

export const PixPaymentCPF: React.FC<ComponentUserRegisterProps> = ({
  handleScreenSelection,
  nextPage,
}) => {
  const formRef = useRef<FormHandles>(null);

  const [btnIsLoading, setBtnIsLoading] = useState<boolean>(false);

  const handleNext = useCallback(async () => {
    const data = formRef?.current?.getData() as formProps;

    try {
      setBtnIsLoading(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        cpf: Yup.string()
          .required('O CPF é obrigatório')
          .length(14, 'Digite um CPF válido')
          .test('cpf', 'Digite um CPF válido', value =>
            getValidationCPF(value),
          ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      nextPage();
    } catch (err) {
      setBtnIsLoading(false);
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }
    }
  }, [nextPage]);

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={3} titles={stepLabels} />
      <h1>Pagar com Pix</h1>

      <SelectedPlanContainer>
        <PlanInfoContainer>
          <span>Assinatura</span>
          <span className="timeFrame">Assistente Virtual</span>
        </PlanInfoContainer>
        <PlanPriceContainer>
          <PriceContainer>
            <span>
              R$ 290,00 <span className="smallText">no Cartão</span>
            </span>
          </PriceContainer>
          <span>Descrição:</span>
          <span className="highlightedText">Assinatura mensal</span>
          <span className="highlightedText">R$ 40,00</span>
          <span>+ R$ 250,00</span>
          <span>Pulseira inteligente</span>
        </PlanPriceContainer>
      </SelectedPlanContainer>
      <FormContainer>
        <PaymentMethodContainer>
          <SelectedPaymentMethod>
            <img src={PixIcon} alt="" />
            <span>Dados PIX</span>
          </SelectedPaymentMethod>
          <ChangeMethodContainer
            onClick={() => handleScreenSelection(PaymentMethodEnum.CreditCard)}
          >
            <span>ALTERAR</span>
          </ChangeMethodContainer>
        </PaymentMethodContainer>
        <ContainerForm ref={formRef} onSubmit={handleNext}>
          <InputMask
            name="cpf"
            label="CPF do titular"
            type="tel"
            mask="999.999.999-99"
          />
        </ContainerForm>
        <ButtonLoadingForm
          isLoading={btnIsLoading}
          btnType="darkBlue"
          onClick={handleNext}
        >
          Confirmar
        </ButtonLoadingForm>
      </FormContainer>
      <InstructionsContainer>
        <h1>Instruções para pagamento:</h1>
        <div>
          <span>
            1- Realize o pagamento do valor integral do seu plano para a chave
            PIX informada acima.
          </span>
        </div>
        <div className="middleText">
          <span>
            2- Após concluir o pagamento,{' '}
            <span className="highlighted">anexe o comprovante</span> no campo
            acima
          </span>
        </div>
        <div>
          <span>
            3- Assim que o pagamento for confirmado em nosso sistema, você
            receberá um novo e-mail com a confirmação e os próximos passos do
            seu atendimento .{' '}
          </span>
        </div>
      </InstructionsContainer>
    </AnimatedContainer>
  );
};
